//
//
//
//
//
//
//
//
//
//
//
//
//
//

import authUtils from '../../mixins/authUtils'
import AuthLogin from '../../components/auth/AuthLogin.vue'

export default {
  middleware: 'guest',

  layout: 'pre-survey',

  components: { AuthLogin },

  mixins: [authUtils],

  head() {
    return {
      title: 'Selamat Datang dan Bergabung Charm Girls!',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            this.getRedirectMetaDescription() ||
            `Silahkan login dengan alamat e-mail atau akun Facebook kamu dan Selamat Datang di Halaman Charmgirlstalk !`,
        },
      ],
    }
  },
}
